module.exports = __webpack_public_path__ + "img/ng.992459a3.svg";